export enum LogisticsType {
  Delivery = "DELIVERY",
  SetupDelivery = "SETUP_DELIVERY",
  PickUp = "PICK_UP",
  Return = "RETURN",
  PickUpAndDelivery = "PICK_UP_AND_DELIVERY",
  Special = "SPECIAL",
}

export const logisticsTypeLabel: Record<LogisticsType, string> = {
  [LogisticsType.Delivery]: "배송",
  [LogisticsType.SetupDelivery]: "세팅배송",
  [LogisticsType.PickUp]: "수거",
  [LogisticsType.Return]: "반납",
  [LogisticsType.PickUpAndDelivery]: "맞수거/복합",
  [LogisticsType.Special]: "특수/비정기",
};

// Header label expected in the uploaded excel (optional column).
// Header text -> LogisticsType. Keep entries forgiving (trim + lowercase).
const HEADER_VALUE_MAP: Record<string, LogisticsType> = {
  "배송": LogisticsType.Delivery,
  "세팅배송": LogisticsType.SetupDelivery,
  "세팅": LogisticsType.SetupDelivery,
  "수거": LogisticsType.PickUp,
  "반납": LogisticsType.Return,
  "맞수거": LogisticsType.PickUpAndDelivery,
  "맞수거/복합": LogisticsType.PickUpAndDelivery,
  "복합": LogisticsType.PickUpAndDelivery,
  "특수": LogisticsType.Special,
  "비정기": LogisticsType.Special,
  "특수/비정기": LogisticsType.Special,
};

export function parseLogisticsTypeCell(
  cell: unknown,
): LogisticsType | undefined {
  if (cell === null || cell === undefined) return undefined;
  const text = String(cell).trim();
  if (!text || text === "null") return undefined;
  if (text in HEADER_VALUE_MAP) return HEADER_VALUE_MAP[text];
  // Allow raw enum values too ("DELIVERY", etc.)
  const upper = text.toUpperCase();
  if ((Object.values(LogisticsType) as string[]).includes(upper)) {
    return upper as LogisticsType;
  }
  return undefined;
}
